module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/vu-87d69c1826cf7245c2d83ae1d4e4a7fb.svg";